import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InjectLocalStorage, InjectQueryParam, LocalStorageKey } from '@ddt-web/generic-utils';
import { DebugQueryParamKey, PartnerQueryParamKey, UrlUtils } from '@ddt-web/url';
import { APM_CLEAN_REIMPORTED_RESPONSE, APM_CLEAN_RESPONSE, APM_DIRTY_RESPONSE_WITH_SECURITY, APM_DIRTY_RESPONSE_WITH_SLEEVE, APM_WITH_ONE_VALID_ONE_SUBSTITUTED_ASSET_CLASS, APM_WITH_SINGLE_ASSET_CLASS_SUBSTITUTION, APM_WITH_TWO_SUBSTITUTED_ASSET_CLASS, CREATE_UPDATE_MODEL_MOCK_RESPONSE_INVALID, GET_MODEL_LIST_MOCK_RESPONSE, GET_PROGRAM_HANDLES_MOCK_RESPONSE, GET_RISK_SCALES_MOCK_RESPONSE, OLD_APM_DIRTY_PORTFOLIO_RESPONSE, OLD_APM_DIRTY_PORTFOLIO_RESPONSE_2, SAMPLE_GET_MODEL_RESPONSE, UMA_GET_MODEL_CLEAN, UMA_GET_MODEL_CLEAN_REIMPORT, UMA_GET_MODEL_DIRTY, UMA_GET_MODEL_DIRTY_2, UMA_GET_MODEL_DIRTY_REIMPORT, UMA_GET_MODEL_REIMPORT } from '@test-data/dummy-backend-data/external-data-responses';
import * as get from 'lodash/get';
import { Observable, of } from 'rxjs';

import * as ippBatchGetResponse from '../../../../../test_data/dummy-backend-data/ipp-batch-get.json';

@Injectable()
export class PartnerInterceptorService implements HttpInterceptor {

	@InjectQueryParam(DebugQueryParamKey.USE_EXT_PARTNER_BETA) private readonly useExtPartnerBeta: string;
	@InjectLocalStorage(LocalStorageKey.MockExtPartnerBatchGet) private readonly mockExtPartnerBatchGet: boolean;

	public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		const isPartnerRequest = request.url.includes('envestnet');
		const mockAPIEnabled = Boolean(localStorage.getItem(PartnerQueryParamKey.MOCK_PARTNER_API));

		if (isPartnerRequest && mockAPIEnabled) {
			return this.getMockPartnerResponse(next, request);
		}

		const isExternalPartnerRequest = request.url.includes('/wealth/integrations/');
		if (isExternalPartnerRequest) {
			request = this.addChannelHeader(request);

			if (this.mockExtPartnerBatchGet && request.url.includes('accounts:batchGet')) {
				const response = new HttpResponse({ body: ippBatchGetResponse });
				return of(response);
			}
		}

		return next.handle(request);
	}

	private addChannelHeader(request: HttpRequest<any>): HttpRequest<any> {
		const isBetaApp =
			this.useExtPartnerBeta === 'true' ||
			this.useExtPartnerBeta === null && UrlUtils.isProduction() && (window.location.href.includes('-beta') || window.location.href.includes('-pilot'));
		if (isBetaApp && this.useExtPartnerBeta !== 'false') {
			const requestCloned = request.clone({
				setHeaders: {
					'VND.Com.blackrock.Channel': 'beta'
				}
			});
			return requestCloned;
		}

		return request;
	}

	private getMockPartnerResponse(next: HttpHandler, request: HttpRequest<any>): any {
		let body = {};

		if (request.url.includes('program-handles')) {
			body = GET_PROGRAM_HANDLES_MOCK_RESPONSE;
		} else if (request.url.includes('risk-scales')) {
			body = GET_RISK_SCALES_MOCK_RESPONSE;
		} else if (request.url.includes('models')) {
			const isCreateModelApi = request.method === 'POST';
			const isModelListApiCall = request.url.endsWith('models/') || request.url.endsWith('models');

			const urlModelMatches = request.url.match(/models\/([\w-]+)/);
			const isModelApiCall = urlModelMatches && urlModelMatches.length > 1;

			if (isCreateModelApi) {
				const mockAPISaveSuccess: boolean = localStorage.getItem(LocalStorageKey.MockPartnerApiSaveSuccess) === 'true';
				if (!mockAPISaveSuccess) {
					body = CREATE_UPDATE_MODEL_MOCK_RESPONSE_INVALID;
				} else {
					body = SAMPLE_GET_MODEL_RESPONSE;
				}
			} else if (isModelListApiCall) {
				body = GET_MODEL_LIST_MOCK_RESPONSE;
			} else if (isModelApiCall) {
				const externalModelId = urlModelMatches[1];
				const umaResponses = [APM_CLEAN_RESPONSE, APM_DIRTY_RESPONSE_WITH_SLEEVE, APM_DIRTY_RESPONSE_WITH_SECURITY, APM_WITH_TWO_SUBSTITUTED_ASSET_CLASS,
					APM_WITH_SINGLE_ASSET_CLASS_SUBSTITUTION, UMA_GET_MODEL_CLEAN, UMA_GET_MODEL_DIRTY, UMA_GET_MODEL_DIRTY_2, UMA_GET_MODEL_REIMPORT,
					APM_WITH_ONE_VALID_ONE_SUBSTITUTED_ASSET_CLASS, OLD_APM_DIRTY_PORTFOLIO_RESPONSE, OLD_APM_DIRTY_PORTFOLIO_RESPONSE_2];
				body = umaResponses.find(response => get(response, 'response.id') === externalModelId);
				if (request.params.has('overrideOnReimport') && request.params.get('overrideOnReimport')) {
					const umaReimportedResponses = [UMA_GET_MODEL_DIRTY_REIMPORT, APM_CLEAN_REIMPORTED_RESPONSE, UMA_GET_MODEL_CLEAN_REIMPORT];
					body = umaReimportedResponses.find(response => get(response, 'response.id') === externalModelId);
				}
			}
		}

		const response = new HttpResponse({ body: body });
		console.log('Intercepting response', response);
		return of(response);
	}
}
